import { render, staticRenderFns } from "./FloorControl.vue?vue&type=template&id=d0a01a56&"
import script from "./FloorControl.vue?vue&type=script&lang=js&"
export * from "./FloorControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports